"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitingTemplate = exports.ErrorTemplate = exports.WarningTemplate = exports.SuccessTemplate = exports.InfoTemplate = void 0;
exports.InfoTemplate = "<div class='alert alert-info synNotification' role='alert' data-notificationguid='#=guid#' id='noty_#= guid #'><div style='display: inline-block'>#=text#</div></div>";
exports.SuccessTemplate = "<div class='alert alert-success synNotification' role='alert' data-notificationguid='#=guid#' id='noty_#= guid #'>"
    + "<i class='fa fa-check-circle' /></i>"
    + "<div style='display: inline-block; float: left; margin-right: 5px;'></div>"
    + "<div style='display: inline-block; float: left'>#= text #</div>"
    + "<div style='clear: both' /></div>";
exports.WarningTemplate = "<div class='alert alert-warning synNotification' role='alert' data-notificationguid='#=guid#' id='noty_#= guid #'>"
    + "<i class='fa fa-exclamation-circle' /></i>"
    + "<div style='display: inline-block; float: left; margin-right: 5px;'></div>"
    + "<div style='display: inline-block; float: left'>#= text #</div>"
    + "<div style='clear: both' /></div>";
exports.ErrorTemplate = "<div class='alert alert-danger synNotification' role='alert' data-notificationguid='#=guid#' id='noty_#= guid #'>"
    + "<i class='fa fa-exclamation-triangle' /></i>"
    + "<div style='display: inline-block; float: left; margin-right: 5px;'></div>"
    + "<div style='display: inline-block; float: left'>#= text #</div>"
    + "<div style='clear: both' /></div>";
exports.WaitingTemplate = "<div class='alert alert-waiting synNotification' role='alert' data-notificationguid='#=guid#' id='noty_#= guid #'>"
    + "<img src='assets/images/loading_image.gif' /></i>"
    + "<div style='display: inline-block; float: left; margin-right: 5px;'></div>"
    + "<div style='display: inline-block; float: left'>#= text #</div>"
    + "<div style='clear: both' /></div>";
